// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SecondaryNavigation_wrapper__hzR8v","innerWrapper":"SecondaryNavigation_innerWrapper__TCyip"};